import { useNavigate, useParams } from 'react-router-dom';
import { useStore } from '../../../utils/store';
import { useEffect, useState } from 'react';
import HttpService from '../../../services/HttpService';
import Constants from '../../../utils/constants';
import FormFieldData from '../../../Models/FormFieldData';
import { Stack } from '@mui/material';
import CommonForm from '../../../components/form/CommonForm';
import AlertMessageComponent from '../../../components/AlertMessageComponent';
import { useAlert } from '../../../components/alertContext';

const WarehouseForm: React.FC = () => {
  const { getAdmin } = useStore();
  const { currentId } = useParams<{ currentId: any }>();
  const navigate = useNavigate();

  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [currentRecord, setCurrentRecord] = useState<any>(null);
  type WarehouseObj = {
    [k: string]: { required: boolean; value: string | null };
  };
  const [warehouseForm, setWarehouseForm] = useState<WarehouseObj>({
    id: { required: false, value: null },
    name: { required: true, value: '' },
    location: { required: true, value: '' },
  });
  const [loading, setLoading] = useState(false);

  const handleRowClick = (record: any) => {
    console.log(record);
    setCurrentRecord(record);
    setWarehouseForm({
      id: { required: false, value: record.id },
      name: { required: true, value: record.warehouseName },
      location: { required: true, value: record.location },
    });
  };

  const fetchSingleRecord = async (id: string) => {
    try {
      const response = await HttpService.get(
        `${Constants.apiURL + Constants.warehousesURL}/${id}`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        null
      );
      if (response.success) {
        handleRowClick(response.data);
      }
    } catch (error: any) {
      console.error(`GET Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  const clearForm = () => {
    setWarehouseForm({
      id: { required: false, value: null },
      name: { required: true, value: '' },
      location: { required: true, value: '' },
    });
    setAlert({
      type: 'error',
      message: '',
      open: false,
    });
    setCurrentRecord(null);
    navigate('/data-management/warehouses');
  };

  const handleSave = async () => {
    setLoading(true);
    const reqData: any = {
      warehouseName: warehouseForm.name.value,
      location: warehouseForm.location.value,
    };
    const endpoint = `${Constants.apiURL + Constants.warehousesURL}`;
    let response: any;
    try {
      if (currentRecord) {
        reqData['id'] = warehouseForm.id.value;
        response = await HttpService.put(endpoint, reqData, {
          headers: { Authorization: `Bearer ${getAdmin()}` },
        });
      } else {
        response = await HttpService.post(endpoint, reqData, {
          headers: { Authorization: `Bearer ${getAdmin()}` },
        });
      }

      if (response.success) {
        clearForm();
      }
    } catch (error: any) {
      console.error(`POST Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setWarehouseForm((prevData) => ({
      ...prevData,
      [name]: { ...prevData[name], value: value },
    }));
  };

  useEffect(() => {
    if (currentId) {
      if (currentId !== 'Add') {
        fetchSingleRecord(currentId);
      }
    } else {
      setCurrentRecord(null);
    }
  }, [currentId]);

  const formFields: FormFieldData[] = [
    {
      name: 'name',
      label: 'Warehouse Name',
      value: warehouseForm.name.value,
      onChange: handleInputChange,
      isRequired: warehouseForm.name.required,
      size: 12,
      type: 'textfield',
      validationRules: [
        (value) => (!value ? 'Warehouse name is required' : null),
      ],
    },
    {
      name: 'location',
      label: 'Location',
      value: warehouseForm.location.value,
      onChange: handleInputChange,
      isRequired: warehouseForm.location.required,
      size: 12,
      type: 'textfield',
      validationRules: [
        (value) => (!value ? 'Warehouse location is required' : null),
      ],
    },
  ];
  return (
    <Stack>
      <CommonForm
        fields={formFields}
        onCancel={() => {}}
        formReset={clearForm}
        formTitle={
          currentId !== 'Add' ? 'Update Warehouse' : 'Add New Warehouse'
        }
        isLoading={loading}
        isUpdate={currentId !== 'Add' ? true : false}
        onSave={handleSave}
        actionButtonPosition="bottom"
      />
      <AlertMessageComponent
        type={alert.type}
        open={alert.open}
        handleClose={handleCloseAlert}
        message={alert.message}
      />
    </Stack>
  );
};

export default WarehouseForm;
